module.exports = __webpack_public_path__ + "img/npm.452c116b.svg";